// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__dNspR","content":"RecentSearches_content__2eYqa"};